<template>
  <div class="examenes-view">
    <h2 class="titulo">{{ nombre }} — Exámenes de sangre</h2>
    <p class="subtitulo">RUT {{ rut }}</p>

    <div v-if="loading" class="estado">Cargando...</div>
    <div v-else-if="error" class="error-message">{{ error }}</div>
    <div v-else-if="examenes.length === 0" class="estado">Sin resultados registrados.</div>

    <table v-else class="examenes-tabla">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Examen</th>
          <th>Resultado</th>
          <th>Unidad</th>
          <th>Referencia</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="ex in examenes" :key="ex.id" :class="rowClass(ex)">
          <td class="fecha">{{ formatFecha(ex.fecha) }}</td>
          <td class="examen-nombre">{{ ex.examen }}</td>
          <td class="resultado">{{ ex.resultado }}</td>
          <td class="unidad">{{ ex.unidad || '—' }}</td>
          <td class="referencia">
            <span v-if="ex.intervalo_inferior != null && ex.intervalo_superior != null">
              {{ ex.intervalo_inferior }} – {{ ex.intervalo_superior }}
            </span>
            <span v-else>—</span>
          </td>
          <td class="estado-badge">
            <span v-if="ex.intervalo_inferior == null || ex.intervalo_superior == null" class="badge sin-ref">S/R</span>
            <span v-else-if="enRango(ex)" class="badge normal">Normal</span>
            <span v-else class="badge alterado">Alterado</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import sangreApi from '@/api/sangre';

export default {
  name: 'SangreExamenes',
  props: {
    rut: { type: String, required: true },
    nombre: { type: String, required: true }
  },
  data() {
    return {
      examenes: [],
      loading: false,
      error: null
    };
  },
  watch: {
    rut: {
      immediate: true,
      handler() { this.fetchExamenes(); }
    }
  },
  methods: {
    async fetchExamenes() {
      this.loading = true;
      this.error = null;
      try {
        const response = await sangreApi.getExamenesByRut(this.rut);
        this.examenes = response.data;
      } catch (e) {
        this.error = 'No se pudieron cargar los exámenes.';
      } finally {
        this.loading = false;
      }
    },
    formatFecha(fecha) {
      return new Date(fecha).toLocaleDateString('es-CL', {
        year: 'numeric', month: '2-digit', day: '2-digit'
      });
    },
    enRango(ex) {
      const v = parseFloat(ex.resultado);
      return v >= parseFloat(ex.intervalo_inferior) && v <= parseFloat(ex.intervalo_superior);
    },
    rowClass(ex) {
      if (ex.intervalo_inferior == null || ex.intervalo_superior == null) return '';
      return this.enRango(ex) ? 'row-normal' : 'row-alterado';
    }
  }
};
</script>

<style scoped>
.examenes-view {
  max-width: 960px;
}
.titulo {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.2em;
}
.subtitulo {
  color: #718096;
  font-size: 0.9rem;
  margin-bottom: 1.5em;
}
.estado {
  color: #718096;
  padding: 2em 0;
}
.examenes-tabla {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.93rem;
}
.examenes-tabla th {
  background: #2d3748;
  color: #fff;
  padding: 0.65em 1em;
  text-align: left;
  font-weight: 600;
  letter-spacing: 0.03em;
}
.examenes-tabla td {
  padding: 0.55em 1em;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
}
.examenes-tabla tbody tr:hover {
  background: #f7fafc;
}
.row-alterado td {
  background: #fff5f5;
}
.row-alterado td.examen-nombre {
  font-weight: 600;
}
.fecha { white-space: nowrap; color: #4a5568; }
.examen-nombre { text-transform: capitalize; }
.resultado { font-weight: 600; color: #2d3748; }
.unidad { color: #718096; font-size: 0.85rem; }
.referencia { color: #718096; font-size: 0.85rem; white-space: nowrap; }
.badge {
  display: inline-block;
  padding: 0.2em 0.7em;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.badge.normal  { background: #c6f6d5; color: #276749; }
.badge.alterado { background: #fed7d7; color: #c53030; }
.badge.sin-ref { background: #e2e8f0; color: #718096; }
</style>
